import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { iUnidadMedida } from '../models/iUnidadMedida.model';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';


@Injectable({
  providedIn: 'root'
})
export class UnidadService {

  constructor(private apiService: ApiService) { }

  insertar(data: iUnidadMedida): Observable<any> {
    this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.unidad_medida_CRUD_url);
    return this.apiService.executePostJson(data).pipe();
  }

  modificar(data: iUnidadMedida): Observable<any> {
    this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.unidad_medida_CRUD_url);
    return this.apiService.executePutJson(data).pipe();
  }

  eliminar(id: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.unidad_medida_CRUD_url);
    return this.apiService.executeDeleteJson(`/${id}`)
  }

  obtener(id: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.unidad_medida_CRUD_url);
    return this.apiService.execGetQueryJson(`/${id}`)
  }

  buscar(tipinv: any, codart: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.unidad_medida_CRUD_url);
    return this.apiService.execGetQueryJson(`/buscar?tipinv=${tipinv}&codart=${codart}`)
  }

}
